module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a5-6-1325664500aa38e054d2539fc12f44b0.jpg";